import moment from "moment";
import React from "react";
import ResponsivePagination from "react-responsive-pagination";

import CONSTANT from "../../../constant";
import { getLoginLog, searchLoginLog } from "../../../actions/AuthAction";
import Header from "../../../component/common/AdminHeader";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      list: undefined,
      total: 0,
      showLoader: false,
      keyword: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.adminSection;
    this.loadList(this.state.page);
  }

  render() {
    const { list } = this.state;
    return (
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Login Log Report</h1>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <form className="searchhome">
                      <i className="fa fa-search d-inline-block"></i>
                      <input
                        type="text"
                        name="k"
                        className="form-control search-bar d-inline-block"
                        placeholder="Search by employee no, name or department"
                        onChange={this.onChange}
                      />
                    </form>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr>
                              <th scope="col" className="text-nowrap">S.No.</th>
                              <th scope="col" className="text-nowrap">Employee No.</th>
                              <th scope="col" className="text-nowrap">Name</th>
                              <th scope="col" className="text-nowrap">Department</th>
                              <th scope="col" className="text-nowrap">IP Address</th>
                              <th scope="col" className="text-nowrap">Login Time</th>
                              <th scope="col" className="text-nowrap">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {list === undefined && (
                              <tr>
                                <td colSpan={7} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}
                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={7} className="text-center">
                                  No records found
                                </td>
                              </tr>
                            )}
                            {list !== undefined &&
                              list.map((item: any, index: number) => {
                                return (
                                  <tr className="c-pointer" key={index}>
                                    <td>{(this.state.page - 1) * 10 + index + 1}</td>
                                    <td>{item?.employeeNo}</td>
                                    <td>{item?.name}</td>
                                    <td>{item?.department}</td>
                                    <td>{item?.ipAddress}</td>
                                    <td>
                                      {item?.loginTime
                                        ? moment.utc(item?.loginTime).format("DD/MM/YYYY hh:mm A")
                                        : "-"}
                                    </td>
                                    <td>
                                      {item?.loggedIn ? (
                                        <span className="badge bg-success">Active</span>
                                      ) : (
                                        <span className="badge bg-secondary">Logged Out</span>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="mt-4 p-4">
                      {list !== undefined && list.length !== 0 && (
                        <ResponsivePagination
                          activeItemClassName="Pagi-number-ac"
                          current={this.state.page}
                          maxWidth={1}
                          total={Math.ceil(this.state.total / 10)}
                          onPageChange={this.handlePageChange}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  loadList = (page: any) => {
    this.setState({ showLoader: true });
    getLoginLog(page).then((res: any) => {
      this.setState({
        list: res.result?.loginLogs,
        total: res.result?.total,
        showLoader: false,
      });
    });
  };

  onChange = (e: any) => {
    this.setState({
      keyword: e.target.value,
    });
    if (e.target.value !== "") {
      searchLoginLog({ keyword: e.target.value }, this.state.page).then((res: any) => {
        this.setState({
          list: res.result?.loginLogs,
          total: res.result?.total,
        });
      });
    } else {
      this.loadList(this.state.page);
    }
  };

  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadList(newPage);
    });
  };
}

export default ComponentName;
